import styles from './style.module.scss';
import Modal from '../../common/modal/Modal';
import Button from '../../ui/Button';
import { str } from 'ajv';
import Loader from '../../common/Loader';

type TokenTransferConfirmationModalProps = {
  open: boolean;
  information: {
    tokenOrSymbol: string;
    TotalTransferAmount: number;
    IndividualTransferAmount: number;
    // DistritionSchedule: string;
  };
  onConfirm: () => void;
  onReject: () => void;
  isLoading?: boolean;
};

const TokenTransferConfirmationModal = ({
  open,
  information,
  onConfirm,
  onReject,
  isLoading,
}: TokenTransferConfirmationModalProps) => {
  return (
    <Modal
      open={open}
      title="Transfer Confirmation"
      onClose={onReject}
      isCloseIconVisible={!isLoading}
      dialogClassName={styles.dialog_content}
    >
      <div className={styles.mintWrapper}>
        <div className={styles.mintItem}>
          <label>Token Name or Symbol:</label>
          <span>{information.tokenOrSymbol}</span>
        </div>
        <div className={styles.mintItem}>
          <label>Transfer Amount:</label>
          <span>{information.IndividualTransferAmount}</span>
        </div>
        {/* <div className={styles.mintItem}>
          <label>Distrition Schedule:</label>
          <span>{information.DistritionSchedule}</span>
        </div> */}
        {/* <div className={styles.mintItem}>
          <label>Minting Date</label>
          <span>{currentDate}</span>
        </div> */}
      </div>
      <div className={styles.actions}>
        <Button variant="outline" onClick={onReject} disabled={isLoading}>
          Reject
        </Button>
        <Button
          variant="dark"
          onClick={onConfirm}
          disabled={isLoading}
          className={styles.delete_btn}
        >
          {isLoading ? <Loader size={15} /> : 'Confirm'}
        </Button>
      </div>
    </Modal>
  );
};

export default TokenTransferConfirmationModal;
